import { OldFilterDTO } from "../application/OldFilterDTO"

export default class ProdutoGenericoHelper {

    public static getFilter(): OldFilterDTO {
        return {
            nome: { field: "nome", rule: "contains", value: "%%" }
        }
    }
}